import classNames from 'classnames'
import prop from 'ramda/src/prop'
import isEmpty from 'ramda/src/isEmpty'
import isNil from 'ramda/src/isNil'
import replace from 'ramda/src/replace'
import pipe from 'ramda/src/pipe'
import withStyles from '@material-ui/core/styles/withStyles'
import { errorColor } from 'root/src/client/web/commonStyles'

const style = {
	root: {
		color: errorColor,
		textAlign: 'center',
		marginBottom: 15,
	},
}

const SubmitError = ({ classes, formSubmitError, submitIndex, clickedIndex }) => (
	<div className={classNames(classes.root)}>
		{!isEmpty(formSubmitError)
			&& !isNil(formSubmitError)
			&& submitIndex === clickedIndex
			&& (pipe(
				prop('errorString'),
				replace('Click Edit to fill missing data.', ''),
			)(formSubmitError)
				|| 'Please fill out all required fields above')}
	</div>
)

export default withStyles(style, { name: 'MuiSubmitError' })(SubmitError)
